import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { useAuth } from '../../contexts/AuthContext';
import { WebRTCProvider } from '../../contexts/WebRTCContext';

interface LayoutProps {
  children?: React.ReactNode;
}

const FULL_WIDTH_ROUTES = ['/sms/inbox'];

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user } = useAuth();
  const { pathname } = useLocation();
  const isFullWidth = FULL_WIDTH_ROUTES.includes(pathname);

  if (!user) {
    return null;
  }

  const content = (
    <div className="min-h-screen bg-background">
      {/* Sidebar */}
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Main content */}
      <div className="lg:pl-64">
        {/* Header */}
        <Header onMenuClick={() => setSidebarOpen(true)} />

        {/* Page content */}
        <main className={isFullWidth ? 'py-0' : 'py-6'}>
          <div
            className={
              isFullWidth
                ? 'w-full h-[calc(100vh-4rem)]'
                : 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'
            }
          >
            {children || <Outlet />}
          </div>
        </main>
      </div>
    </div>
  );

  // Wrap agent, admin, and owner users with WebRTCProvider so the in-call popup,
  // call handling, and admin test calls work on every page
  if (user.role === 'agent' || user.role === 'admin' || user.role === 'owner') {
    return <WebRTCProvider>{content}</WebRTCProvider>;
  }

  return content;
};

export default Layout;